import React, { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

interface Props {
  categories: string[];
  series: {
    name: string;
    data: number[];
    color: string;
  }[];
}

export const Graph: React.FC<Props> = ({ categories, series }) => {
  const groupPadding = useMemo(() => {
    if (categories.length <= 1) {
      return 0.445;
    }
    if (categories.length <= 2) {
      return 0.38;
    }
    if (categories.length <= 3) {
      return 0.315;
    }
    return 0.27;
  }, [categories]);

  const options: Highcharts.Options = {
    chart: {
      type: "column",
      height: 250,
      backgroundColor: "transparent",
      scrollablePlotArea: {
        scrollPositionX: 0,
        minWidth: categories.length * 250
      }
    },
    title: {
      text: undefined
    },
    credits: {
      enabled: false
    },
    exporting: {
      enabled: false
    },
    xAxis: {
      categories,
      lineWidth: 0,
      tickWidth: 0,
      labels: {
        style: {
          color: "#496682",
          fontSize: "12px"
        }
      }
    },
    yAxis: {
      title: {
        text: undefined
      },
      gridLineColor: "#ECF1F8",
      lineWidth: 0,
      tickWidth: 0,
      labels: {
        enabled: false
      }
    },
    legend: {
      enabled: true,
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal",
      itemStyle: {
        color: "#496682",
        fontSize: "12px",
        fontWeight: "400"
      }
    },
    plotOptions: {
      column: {
        pointWidth: 50,
        groupPadding: groupPadding,
        pointPadding: 0.05,
        borderRadius: 2,
        borderWidth: 0,
        minPointLength: 3
      }
    },
    series: series.map((s) => ({
      ...s,
      type: "column"
    }))
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
